/**
 * Company: AltSolution
 */
"use strict";

const LANGUAGE = document.getElementsByTagName('html')[0].getAttribute('lang');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {

    //TODO: if url will be have some hash, update this function
    window.scrollTo(0, 0);

    function disable_scroll_mobile(){
        window.addEventListener('touchmove', wheel, { passive: false });
    }
    function enable_scroll_mobile(){
        window.removeEventListener('touchmove', wheel, { passive: false });
    }
    var keys = [32,33,34,35,36,37,38,39,40];
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                if(e.target.type !== 'text' &&
                    e.target.type !== 'textarea' &&
                    e.target.type !== 'search' &&
                    e.target.type !== 'email') {
                    preventDefault(e);
                    return;
                }
            }
        }
    }

    function wheel(e) {
        preventDefault(e);
    }
    function disable_scroll() {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel);
        }
        window.addEventListener('mousewheel', wheel, { passive: false });
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }
    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel);
        }
        window.removeEventListener('mousewheel', wheel, { passive: true });
        enable_scroll_mobile();
    }

    /*** iOS Body Scroll Lock with open menu/other modal blocks ***/

    var $docEl = $('body'),
    scrollTop;
    var overlayClose = function() {
        $.unlockBody();
    }
    var overlayOpen = function() {
        $.lockBody();
    }
    $.lockBody = function() {
        blockActionHeader = 1;
        if(window.pageYOffset) {
            scrollTop = window.pageYOffset;
        }
        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
        $('html').css({
            height: "100%",
            overflow: "hidden"
        });
    }
    $.unlockBody = function() {
        $docEl.css({
            height: "",
            overflow: ""
        });
        $('html').css({
            height: "",
            overflow: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
            blockActionHeader = 0;
        }, 200);
    };

    /* open blocks in header */
    $('.search-button').on('click', function() {
        $('.search_block').fadeIn(300);
        $('.overlay_page').fadeIn(200);
        $('#search').trigger('focus');
        // if(window.innerWidth < 1092){
        //     disable_scroll();
        // } else {
        //     $('body').css({'overflow': 'hidden', 'height': '100%'});
        //     $('html').css({'overflow': 'hidden'});
        // }
        disable_scroll();
    });
    $('.search_block .close-button').on('click', function() {
        $('.search_block').fadeOut(300);
        $('.search_result').fadeOut(300);
        $('.overlay_page').fadeOut(200);
        $('#search').val('');
        // if(window.innerWidth < 1092){
        //     enable_scroll();
        // } else {
        //     $('body').css({'overflow': 'auto', 'height': 'auto'});
        //     $('html').css({'overflow': 'auto'});
        // }
        disable_scroll();
    });
    $('.header_mobile .menu-button').on('click', function() {
        $('#menu_items--mobile').animate({right: '0'}, 200);
        if(window.innerWidth < 1092){
            overlayOpen();
        } else {
            // $('body').css({'overflow': 'hidden', 'height': '100%'});
            // $('html').css({'overflow': 'hidden'});
            disable_scroll();
        }

    });


    $('.right_bar_info').on('click', function(e) {

        e.preventDefault();
        if(window.innerWidth < 1092){
            overlayOpen();
        } else {
            disable_scroll();
        }

        $('#menu_' + $(this).attr('data-class')).animate({right: '0'}, 200);

        if($(this).attr('data-back') === 'false') {
            $('#menu_' + $(this).attr('data-class')).find('.close-button').attr('data-back', 'false');
        } else {
            $('#menu_' + $(this).attr('data-class')).find('.close-button').attr('data-back', 'true');
        }

        $('.overlay_page').fadeIn(200);
    });


    // $('.cart').on('click', function(e) {
    //     e.preventDefault();
    //
    //     if(window.innerWidth < 1092){
    //         overlayOpen();
    //     } else {
    //         disable_scroll();
    //     }
    //     $('#menu_cart').animate({right: '0'}, 200);
    //     $('.overlay_page').fadeIn(200);
    // });

    $('.header_desktop .menu-button').on('click', function() {
        $('#menu_items--big').animate({right: '0'}, 200);
        $('.overlay_page').fadeIn(200);
        if(window.innerWidth < 1092){
            overlayOpen();
        } else {
            disable_scroll();
            // $('body').css({'overflow': 'hidden', 'height': '100%'});
            // $('html').css({'overflow': 'hidden'});
        }
    });

    $('header .close-button').on('click', function() {
        if($(this).attr('data-back') === 'true') {
            $(this).closest('.right_bar_info_popup ').animate({right: '-100%'}, 200);
        } else {
            $('.menu').animate({right: '-100%'}, 200);
            $('.overlay_page').fadeOut(200);
            if(window.innerWidth < 1092){
                overlayClose();
            } else {
                enable_scroll();
                // $('body').css({'overflow': 'auto', 'height': 'auto'});
                // $('html').css({'overflow': 'auto'});
            }
        }
    });
    $('.overlay_page').on('click', function() {

        $('#menu_items--big').animate({right: '-100%'}, 200);

        // $('#menu_delivery').animate({right: '-100%'}, 200);
        // $('#menu_payment').animate({right: '-100%'}, 200);
        $('.right_bar_info_popup').animate({right: '-100%'}, 200);

        $('#menu_cart').animate({right: '-100%'}, 200);
        $('#menu_profile').animate({right: '-100%'}, 200);
        $('#menu_items--mobile').animate({right: '-100%'}, 200);
        $('.overlay_page').fadeOut(200);
        $('.search_block').fadeOut(300);
        $('.glasses_choise').fadeOut(200);
        $('.search_result').fadeOut(300);
        $('#search').val('');
        $('.filter_block').animate({left: '-100%'}, 200);
        $('.result_category').animate({left: '-100%'}, 200);
        if(window.innerWidth < 1092){
            //overlayClose();
            enable_scroll();
        } else {
            // $('body').css({'overflow': 'auto', 'height': 'auto'});
            // $('html').css({'overflow': 'auto'});
            //overlayClose();
            enable_scroll();
        }
    });

    if($('.search_page').length){
        $('.catalog_filter').on('click', '.filter', function(e) {
            e.preventDefault();
            if(window.innerWidth < 1092){
                overlayOpen();
            } else {
                disable_scroll();
                // $('body').css({'overflow': 'hidden', 'height': '100%'});
                // $('html').css({'overflow': 'hidden'});
            }
            if($(this).attr('data-category') === 'true') {
                $('.filter_block').animate({left: '0'}, 200);
                $('.filter_block').addClass('open');
            } else {
                $('.result_category').animate({left: '0'}, 200);
            }
            $('.overlay_page').fadeIn(200);
        });
    } else {
        $('.filter').on('click', function(e) {
            e.preventDefault();
            if(window.innerWidth < 1092){
                overlayOpen();
            } else {
                // $('body').css({'overflow': 'hidden', 'height': '100%'});
                // $('html').css({'overflow': 'hidden'});
                disable_scroll();
            }
            $('.filter_block').animate({left: '0'}, 200);
            $('.filter_block').addClass('open');
            $('.overlay_page').fadeIn(200);
        });
    }
    $('.result_category h3').on('click', function() {
        if(window.innerWidth < 1092){
            overlayOpen();
        } else {
            // $('body').css({'overflow': 'hidden', 'height': '100%'});
            // $('html').css({'overflow': 'hidden'});
            disable_scroll();
        }
        $('.filter_block').animate({left: '0'}, 200);
    });
    $('#xhr-filter, #xhr-filter-search').on('click', '.filter_block__buttons button', function() {
        if(window.innerWidth < 1092){
            overlayClose();
            enable_scroll();
        } else {
            $('body').css({'overflow': 'auto', 'height': 'auto'});
            $('html').css({'overflow': 'auto'});
        }
        enable_scroll();
        $('.filter_block').animate({left: '-100%'}, 200);
        $('.result_category').animate({left: '-100%'}, 200);
        $('.overlay_page').fadeOut(200);
    });

    $('.sort_header').on('click', function() {
        $(this).parent().toggleClass('open-menu');
    });


    $('body').on('click', function(e) {
        var $p = $('p.sort_header');
        if (!$p.is(e.target) && $p.has(e.target).length === 0) {
            $('.sort').removeClass('open-menu');
        }
    });
    $('.sort .select_menu').on('click', 'li:not(.active)', function () {
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        if($(this).attr('data-f') !== 'sort:pop') {
            $(this).closest('.sort').find('.sort_header > i').html( $(this).html());
        } else {
            $(this).closest('.sort').find('.sort_header > i').html($(this).closest('.sort').find('.sort_header').attr('data-sort-n'));
        }
    });

    var textHeight = 0;
    $('.catalog_about__info p').each(function () {
        textHeight += $(this).outerHeight(true);
    });
    $('.read_more').on('click', function() {
        $('.catalog_about__info').toggleClass('open');
        if ($('.catalog_about__info').hasClass('open')) {
            $('.catalog_about__info').animate({'max-height': textHeight + 'px'}, 200);
        } else {
            $('.catalog_about__info').animate({'max-height': '240px'}, 200);
        }
    });


    /* Remove items from cart and show symbol face */
    // $('.cart__close-button').on('click', function() {
    //     $(this).parent().remove();
    //     if($('.cart_item').length == 0) {
    //         $('.cart_block+.buttons_block').remove();
    //         $('.cart_items').remove();
    //         $('.cart_block .empty').fadeIn();
    //     }
    // });

    /** Validation for price input  **/
    $('#xhr-filter, #xhr-filter-search').on('input', '.filter_block .price_input input', function() {
        const current = this.value;
        const corrected = parseInt(current.replace(/([^0-9]+)/gi, ''));
        if(isNaN(corrected)) {
            this.value = 0;
        } else {
            this.value = corrected;
        }
    });

    $('#xhr-filter, #xhr-filter-search').on('blur', '.filter_block .price_input input', function() {
        var priceMin = $(this).parent().parent().find('.price_input:first-child input');
        var priceMax = $(this).parent().parent().find('.price_input:last-child input');
        var priceFrom = parseInt($('#priceFrom').attr('data-min'));
        var priceTo = parseInt($('#priceTo').attr('data-max'));

        if(parseInt(priceMin.val()) < priceFrom) {
            priceMin.val(priceFrom);
        }

        if(parseInt(priceMax.val()) > priceTo) {
            priceMax.val(priceTo);
        }

        if(parseInt(priceMin.val()) >= parseInt(priceMax.val())) {
            priceMin.val(priceFrom);
            priceMax.val(priceFrom + 1);
        }
    });

    /* Counting the height of banners */
    if(window.innerWidth < 768){
        $('.fullscreen_block:not(.catalog_bg, .catalog_text)').css('height', window.innerHeight - 60 + 'px');
    }
    else if(window.innerWidth >= 768 ) {
        $('.fullscreen_block:not(.catalog_bg, .catalog_text)').css('height', window.innerHeight - 80 + 'px');
    }

    /** Filter **/
    if($('.selected_filters span').length == 0) {
        $('.selected_filters').hide();
    }
    $('#xhr-filter, #xhr-filter-search').on('click', '.selected_filters span svg', function() {
        if($(this).parent().hasClass('price')) {
            $('.price_input:first-child input').val($('.price_input:first-child input').attr('data-min'));
            $('.price_input:last-child input').val($('.price_input:last-child input').attr('data-max'));
        } else {
            $('label[for="' + $(this).parent().attr('class') + '"]').trigger('click');
        }
        $(this).parent().remove();
        if($('.selected_filters span').length == 0) {
           $('.selected_filters').slideUp();
        }
    });
    var $filters = $('#xhr-filter, #xhr-filter-search');
    $filters.on('click', '.filter_block .accordion_toggle label', function() {
        if($(this).siblings('input').is(':checked')) {
            $filters.find('.selected_filters span[class="' + $(this).attr('for') + '"]').remove();
            if($filters.find('.selected_filters span').length == 0) {
                $filters.find('.selected_filters').slideUp();
            }
        } else {
            if($filters.find('.selected_filters span').length == 0) {
                $filters.find('.selected_filters').slideDown();
            }
            $filters.find('.selected_filters').append('<span class="' + $(this).attr('for') + '">' + $(this).find('p').text() + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L12 12M22 22L14.5 14.5M22 2L2 22" stroke="black" stroke-width="2"/></svg></span>');
        }
    });
    $filters.on('blur', '.filter_block .price_input input', function() {
        if($('.selected_filters .price'))  {
            $('.selected_filters .price').remove();
        }
        if($('.selected_filters span').length == 0) {
            $('.selected_filters').slideDown();
        }
        if($(this).parent().is(':first-child')) {
            $('.selected_filters .style_h2').after('<span class="price">' + $(this).val() + ' - ' + $(this).parent().siblings('.price_input').find('input').val() + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L12 12M22 22L14.5 14.5M22 2L2 22" stroke="black" stroke-width="2"/></svg></span>');
        } else {
            $('.selected_filters .style_h2').after('<span class="price">' + $(this).parent().siblings('.price_input').find('input').val() + ' - ' + $(this).val() + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L12 12M22 22L14.5 14.5M22 2L2 22" stroke="black" stroke-width="2"/></svg></span>');
        }
    })

    /* Initialize sliders */
    $(".top_glasses__sider").owlCarousel({
        lazyLoad:true,
        margin: 20,
        smartSpeed:450,
        loop:false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:false,
                dots: true,
            },
            767:{
                items:2,
                nav:true,
                autoWidth:true,
                dots: false,
                stagePadding: 20,
            },
            1281:{
                items:4,
                nav:true,
                dots: false,
                stagePadding: 0
            }
        }
    });
    $(".glasses__sider").owlCarousel({
        lazyLoad:true,
        margin: 0,
        loop:false,
        responsiveClass:true,
        smartSpeed: 350,
        items:1,
        responsive:{
            0:{
                nav:false,
                dots: true,
            },
            768:{
                nav:true,
                dots: false,
            }
        }
    });

    /* Change image and text with color change */
    function colorChangeImage() {
        if(window.innerWidth >= 768 ) {
            $('body').on('mouseover', '.item_colors:not(.hover-event) li', function() {
                if(!$(this).hasClass('active')) {
                    $(this).parent().find('.active').removeClass('active');
                    $(this).addClass('active');

                    var colorIndex = $(this).index();
                    $(this).parent().parent().parent().find('.slider_img img').each(function() {
                        $(this).hide();
                    });
                    $(this).parent().parent().parent().find('.slider_img img').eq(colorIndex).fadeIn(200).css('display', 'block');

                    $(this).parent().parent().find('.item_info').each(function() {
                        $(this).hide();
                    });
                    $(this).parent().parent().find('.item_info').eq(colorIndex).fadeIn(200).css('display', 'flex');

                    // rewrite common block link
                    var linkChange = $(this).parent().parent().find('.item_info').eq(colorIndex).attr('data-url');
                    if (linkChange) {
                        $(this).parent().parent().parent().attr('href', linkChange);
                    } else {
                        $(this).parent().parent().parent().attr('href', '');
                    }

                    //rewrite discpunt persentage
                    var saleChange = $(this).parent().parent().find('.item_info').eq(colorIndex).attr('data-sale');
                    if (saleChange > 0) {
                        $(this).parent().parent().parent().find('.sale')
                            .text('[' + saleChange + '%]')
                            .removeAttr('style');
                    } else {
                        $(this).parent().parent().parent().find('.sale')
                            .text('').css('display', 'none');
                    }
                }
            });
        }
    }
    colorChangeImage();

    /* Add shadow to header */
    $(document).on('scroll', function() {
        if($('html').scrollTop() > 0) {
            $('header').addClass('fixed');
        }
        else if($('html').scrollTop() == 0) {
            $('header').removeClass('fixed');
        }
    });

    /* Dropdown for glasses category */
    var hover;
    var unhover;
    $('.glasses_link').on('mouseenter', function() {
        clearTimeout(unhover);
        hover = setTimeout(function() {
            $('.header_desktop').css('z-index', '7');
            $('.glasses_choise').fadeIn(200).css('display', 'flex');
            $('.overlay_page').fadeIn(200);
        }, 300);
    })
    $('.glasses_link').on('mouseleave', function() {
        clearTimeout(hover);
        unhover = setTimeout(function () {
            $('.overlay_page').fadeOut(200);
            $('.glasses_choise').fadeOut(200);
            setTimeout(function() {
                $('.header_desktop').css('z-index', '1');
            },200)
        }, 300);
    });

    /* Dropdown for glasses category */
    var hover1;
    $('.country-button').on('mouseenter', function() {
        hover1 = setTimeout(function() {
            $('.country-button ul').fadeIn(200).css('display', 'flex');
        }, 300);
    })
    $('.country-button').on('mouseleave', function() {
        $('.country-button ul').fadeOut(200);
        clearTimeout(hover1);
    });

    /* Connects custom scrollbar */
    $(".mCustomScrollbar").mCustomScrollbar({
        axis:"y"
    });


    /**
     *
     * Counter
     */
    $(document).on('click', '.counter span:not(.disabled)', function () {
        var $input = $(this).siblings('input'),
            value = Number($input.val()),
            min = Number($input.attr('data-min')),
            max = Number($input.attr('data-max')),
            typeAction = $(this).attr('data-attr');

        if(typeAction === 'plus' && value < max) {
            $input.val(++value);
        } else if (typeAction === 'minus' && value > min) {
            $input.val(--value);
        }

        if(value >= max) {
            $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
        }

        if(value <= 1) {
            $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
        }
    });

    $(document).on('keypress keyup blur', '.counter input', function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });

    $(document).on('blur', '.counter input', function () {
        let max = Number($(this).attr('data-max'));
        if(Number($(this).val()) < Number($(this).attr('data-min'))) {
            $(this).val($(this).attr('data-min'));
            $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
        }

        if(Number($(this).val()) > max) {
            $(this).val(max);
            $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
        }
    });

    /**
     * Tabs
     */
    let $tabArea = $('.tab_area');
    if($tabArea.length) {
        $tabArea.on('click', '.tab_controls a:not(.active, .disabled)', function (e) {
            e.preventDefault();
            let id = $(this).attr('data-id');
            if(id) {
                $(this).parent().find('.active').removeClass('active');
                $(this).addClass('active');

                let $parent = $(this).closest('.tab_area');
                $parent.find('.tab_content').not('#'+id).fadeOut(200).promise().done(function(){
                    $parent.find('#'+id).fadeIn(200);

                    if($parent.attr('data-hash') === 'true') {
                        if(history.pushState) {
                            history.pushState(null, null, '#' + id);
                        }
                        else {
                            location.hash = '#' + id;
                        }
                    }
                })
            } else {
                console.warn('Please set "data-id"!')
            }
        });

        //Show has content
        $tabArea.each(function () {
            let $this = $(this);
            if($this.attr('data-hash')) {
                if(window.location.hash) {
                    //Show tab active
                    let ID = window.location.hash.replace('#', '');
                    $this.find('.tab_controls a').removeClass('active');
                    $this.find('.tab_controls a[data-id="'+ ID +'"]').addClass('active');

                    //Show content
                    $this.find('.tab_content:not(' + window.location.hash + ')').fadeOut(200, function () {
                        $this.find(window.location.hash).fadeIn(200, function () {
                            $('html, body').stop().animate({
                                'scrollTop': $(window.location.hash).offset().top - 200
                            }, 300);
                        });
                    });
                }
            }
        });
    }


    /**
     * Phone mask
     */
    $('.phone_inputmask').inputmask('+38 (999) 999-9999', {
        "oncomplete": function(){
            $(this).addClass('completed');
        },
        "onincomplete": function () {
            $(this).removeClass('completed');
        },
    });

    /**
     * Form validate
     */
    $.validator.methods.email = function( value, element ) {
        return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z-])+\.)+([a-zA-Z]{2,4})+$/.test( value );
    };
    $.validator.methods.tel = function( value, element ) {
        return this.optional( element ) || /^((\+38)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test( value );
    };

    /**
     * Drop down
     */
    let $dropDown = $('.drop_down');
    if($dropDown.length) {

        $dropDown.on('click', '.drop_down-list li:not(.active):not(.empty)', function () {
            let value = $(this).html();
            $(this).parent().find('li').removeClass('active');
            $(this).addClass('active');

            $(this).closest('.drop_down').find('input').val(value).attr('data-id', $(this).attr('data-id'));
            $(this).closest('.drop_down').removeClass('open');
        });

        //For open after click
        $dropDown.find('input').on('click', function () {
            if($(this).closest('.drop_down').hasClass('disabled')) return false;
            $dropDown.not($(this).closest('.drop_down')).removeClass('open');
            $(this).closest('.drop_down').toggleClass('open');

            //Toggle focus
            if($(this).is(":focus") && !$(this).closest('.drop_down').hasClass('open')) {
                $(this).blur();
                checkSelect();
            } else {
                $(this).focus();
            }
        });

        $(document).on('mouseup', function (e) {
            if ($dropDown.has(e.target).length === 0){
                $dropDown.removeClass('open');
                checkSelect();
            }
        });
    }

    /**
     * Clear value if user dosen`t selected or search was empty.
     */
    function checkSelect() {
        $dropDown.each(function () {
            if($(this).find('.drop_down-list li.active').length === 0) {
                $(this).find('input').val('');
                $(this).find('ul li').removeAttr('style');
                $(this).find('ul li.empty').css('display', 'none');
            }
        });
    }

    /**
     * Drop down search
     */
    let $dropDownSearch = $('.drop_down_search');
    if($dropDownSearch.length) {
        $dropDownSearch.find('input').on('keyup', function () {

            let val = $(this).val().toLowerCase(),
                $searchThis = $(this).closest('.drop_down_search').find('.drop_down-list li'),
                found = 0;

            $searchThis.each(function () {
                if(!$(this).hasClass('empty')) {
                    if ($(this).html().toLowerCase().indexOf(val) === -1) {
                        $(this).css('display', 'none');
                    } else {
                        $(this).removeAttr('style').removeClass('active');
                        found++;
                    }
                }
            });



            if(found <= 0 && val.length > 0) {
                $(this).closest('.drop_down_search').find('.drop_down-list li.empty').removeAttr('style');
            } else {
                $(this).closest('.drop_down_search').find('.drop_down-list li.empty').css('display', 'none');
            }
        })
    }

    /**
     * Open|Close popups
     */
    let $openPanel = $('.open_panel');
    $openPanel.on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        if(id) {
            $('#' + id).addClass('open');
            $('.overlay_page').fadeIn(200);

            if(window.innerWidth < 1092){
                overlayOpen();
            } else {
                disable_scroll();
            }
        } else {
            console.warn('Set Id to popup!');
        }
    });

    //Close
    let $close = $('.wrap_right_bar .close-button, .overlay_page');
    $close.on('click', function (e) {
        if($(this).hasClass('close-button')) {
            e.preventDefault();
        }
        $('.wrap_right_bar').removeClass('open');
        $('.overlay_page').fadeOut(200);

        if(window.innerWidth < 1092){
            overlayClose();
        } else {
            enable_scroll();
        }
    });


    /**
     * Open|Close fadeIn popups
     */
    let $openFadePopups = $('.open_popup');
    $openFadePopups.on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        if(id) {
            $('#' + id).fadeIn(200);
            $('.overlay_page').fadeIn(200);

            if(window.innerWidth < 1092) {
                overlayOpen();
            } else {
                disable_scroll();
            }
        } else {
            console.warn('Set Id to popup!');
        }
    });

    //Close
    let $closeFadePopup = $('.actions_popup .close-button, .overlay_page');
    $closeFadePopup.on('click', function (e) {
        if($(this).hasClass('close-button')) {
            e.preventDefault();
        }
        $('.wrap_right_bar').fadeOut(200);
        $('.overlay_page').fadeOut(200);

        if(window.innerWidth < 1092){
            overlayClose();
        } else {
            enable_scroll();
        }
    });


    //Loaded
    $('.wrap_right_bar').removeAttr('style');

    /**
     * Fix for Edge
     */
    APP.edge_replace.on();

    /**
     * Cookies
     */
    function setCookie(name, value) {
        var date = new Date(new Date().getTime() + 720*60*60*1000);
        document.cookie = ""+ name +"="+ value +"; path=/; expires=" + date.toUTCString();
    }
    function getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /**
     * Ending words
     */
    function declOfNum(number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }


    /**
     * Cart actions
     */
    //Add to cart
    $(document).on('click', '.add_to_card', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return false;

        var cookeOrders = {},
            id = $(this).attr('data-id'),
            max = Number($(this).attr('data-max'));

        if(getCookie('card') === undefined) {
            cookeOrders[id] = {count: 1};
        } else {
            cookeOrders = JSON.parse(getCookie('card'));
            if(cookeOrders[id]) {
                if(cookeOrders[id]['count'] < max) {
                    cookeOrders[id] = {count: Number(cookeOrders[id].count) + 1}
                }
            } else {
                cookeOrders[id] = {count: 1};
            }
        }
        setCookie('card', JSON.stringify(cookeOrders));
        ajaxLoadCard();
        showHideBuy();

        if(window.innerWidth < 1092){
            overlayOpen();
        } else {
            disable_scroll();
        }

        $('.actions_popup--add, .overlay_page').fadeIn(200);
    });

    //Close actions popup
    let $closeActions = $('.overlay_page, .actions_popup .close-button');
    $closeActions.on('click', function (e) {
        if($(this).hasClass('close-button')) {
            e.preventDefault();
        }
        $('.actions_popup, .overlay_page').fadeOut(200);

        if(window.innerWidth < 1092){
            overlayClose();
        } else {
            enable_scroll();
        }
    });

    //Ajax load products from cookies for small basked
    let $basketBlock = $('#menu_cart');
    function ajaxLoadCard() {
        let idS = (getCookie('card') !== undefined) ? getCookie('card') : null;

        if(idS == '{}') {
            idS = null;
        }

        let data = {card: idS};

        //Get data
        $.ajax({
            type: "POST",
            url: '/' + LANGUAGE + '/cookies_products',
            data: data
        }).done(function (data) {
            $basketBlock.find('.cart_items .mCSB_container').html(data.small_basked);
            discountOneHalfTwo($basketBlock.find('.cart_item'));
            calculateSmallCard();
            APP.edge_replace.on();
        });
    }
    if($basketBlock.length) {
        ajaxLoadCard();
    }

    //Show|hide buy button
    function showHideBuy() {
        let idS = (getCookie('card') !== undefined) ? getCookie('card') : null,
            $addCart = $('.add_to_card');

        $addCart.find('.bought').css('display', 'none');
        $addCart.find('.buy').removeAttr('style');

        if(idS) {
            Object.keys(JSON.parse(idS)).map(function(objectKey, index) {
                let $el = $('.add_to_card[data-id="'+ objectKey +'"]');
                $el.find('.buy').css('display', 'none');
                $el.find('.bought').removeAttr('style');
            });
        }

    }
    showHideBuy();

    //Calculate products in small basked after update data and reload page
    function calculateSmallCard() {
        let $cartButton = $('.cart-button'),
            $basketBlock = $('#menu_cart'),
            total = 0,
            totalWithoutDiscount = 0,
            count = 0;

        //Set count to each form
        if(getCookie('card') !== undefined) {
            var cookiesCard = JSON.parse(getCookie('card'));
            $('#menu_cart .cart_items .cart_item').each(function () {
                var id = $(this).attr('data-id');
                $(this).find('.counter input').val(cookiesCard[id]['count']);
            });
        }

        if($basketBlock.find('.cart_items .cart_item').length) {
            $basketBlock.find('.cart_items').removeAttr('style');
            $basketBlock.find('.buttons_block').removeAttr('style');
            $basketBlock.find('.empty').removeAttr('style');

            $basketBlock.find('.cart_items .cart_item').each(function () {
                var discountPrice = Number($(this).find('.price').attr('data-total-promo'));
                if(discountPrice > 0) {
                    total += discountPrice;
                } else {
                    total += Number($(this).find('.price').attr('data-price')) * $(this).find('.counter input').val();
                }
                totalWithoutDiscount += Number($(this).find('.price').attr('data-price')) * $(this).find('.counter input').val();

                count++;
            });

            $('#card--mobile').html('['+ count +']');
            $cartButton.find('span').html('['+ count +']');

            var discount = totalWithoutDiscount - total;

            if(discount > 0) {
                $basketBlock.find('.price_discount_wrap').removeAttr('style');
            } else {
                $basketBlock.find('.price_discount_wrap').css('display', 'none');
            }

            $basketBlock.find('#sm_price_discount').html('-' + discount.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
            $basketBlock.find('#sm_price').html(total.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));

        } else {
            $('#card--mobile').html('[0]');
            $cartButton.find('span').html('[0]');
            $basketBlock.find('.cart_items').css('display', 'none');
            $basketBlock.find('.buttons_block').css('display', 'none');
            $basketBlock.find('.empty').css('display', 'block');
        }
    }

    // Calculate price in card page & checkout page
    var $cardRow = $('.checkout_wrap-cart');
    if($cardRow.length) {
        $cardRow.find('.counter input').on('blur', function () {
            //calculateCheckout();

            var id = $(this).closest('article').attr('data-id'),
                count = $(this).val();

            changeCount(id, count);

            discountOneHalfTwo($('.basket_article'));
            calculateCart();
        });
        $(document).on('click', '.basket_article .counter span', function () {
            //calculateCheckout();

            var id = $(this).closest('article').attr('data-id'),
                count = $(this).parent().find('input').val();

            changeCount(id, count);

            discountOneHalfTwo($('.basket_article'));
            calculateCart();
        });
    }

    $(document).bind('calculate.cart', function () {
        calculateCart();
        calculateCheckout();
    })

    function calculateCart() {
        var total = 0,
            totalWithoutPromo = 0;

        $('.basket_article').each(function () {
            var counter = Number($(this).find('.counter input').val()),
                price = Number($(this).find('.price').attr('data-price')),
                promo = Number($(this).find('.price').attr('data-total-promo'));

            if(promo > 0) {
                total = total + promo;
            } else {
                total = total + (counter * price);
            }
            totalWithoutPromo = totalWithoutPromo + (counter * price);
        });

        var $cartTotal = $('.go_order');

        var discount = totalWithoutPromo - total;

        //Promo discount
        let promoCodeD = discountPromoCode(total, $('.promos-active li'));
        if(promoCodeD) {
            discount += promoCodeD;
            total = total - promoCodeD;
        }

        //Hide if zero
        if(discount <= 0) {
            $cartTotal.find('.price_wrap').css('display', 'none');
            $cartTotal.find('.price_discount_wrap').css('display', 'none');
        } else {
            $cartTotal.find('.price_wrap').removeAttr('style');
            $cartTotal.find('.price_discount_wrap').removeAttr('style')
        }

        $cartTotal.find('#price').html(totalWithoutPromo.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $cartTotal.find('#price_discount').html('-' + discount.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $cartTotal.find('#price_total').html(total.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
    }
    if($cardRow.length) {
        discountOneHalfTwo($('.basket_article'));
        calculateCart();
    }

    //Calculate promo code discount
    function discountPromoCode(total, $elements) {
        if($elements.length) {
            let totalDiscount = 0;
            $elements.each(function () {
                let val = $(this).attr('data-val');
                if($(this).attr('data-type') === '1') {
                    totalDiscount += (val / 100) * total;
                } else if($(this).attr('data-type') === '2') {
                    totalDiscount += val;
                }
            });
            return parseInt(totalDiscount);
        }
        return null;
    }

    //Calculate discount
    function discountOneHalfTwo($elements) {
        var countF = 0;
        $elements.each(function () {
            if($(this).attr('data-sale') === 'false') {
                if($(this).attr('data-collection') === 'rayo' || $(this).attr('data-collection') === 'centr'
                    && $(this).find('.price').attr('data-promo-tr') === 'true') {
                    countF += Number($(this).find('.counter input').val());
                } else if($(this).attr('data-collection') === 'padik') {
                    var count = Number($(this).find('.counter input').val()),
                        price = Number($(this).find('.price').attr('data-price')),
                        totalPrice = 0;

                    if(countF === 0 && count === 1) {
                        console.log('Level 1');
                        if ($(this).find('.price').attr('data-promo-tr') === 'true') {
                            countF++;
                        }
                        $(this).find('.price').attr('data-total-promo', 0);
                    } else if(countF > 0 && count === 1) {
                        console.log('Level 2');
                        totalPrice = 0;
                        if(countF > 0) {
                            totalPrice = totalPrice + (price / 2);
                            countF--;
                        }
                        $(this).find('.price').attr('data-total-promo', totalPrice);
                    } else if (countF === 0 && count > 1) {
                        console.log('Level 3');
                        var loopL = 0;
                        if ($(this).find('.price').attr('data-promo-tr') === 'true') {
                            if (count % 2 === 0 ) {
                                loopL = count / 2;
                            } else {
                                loopL = Math.floor(count / 2);
                                countF++;
                            }
                        }
                        for(var i = 1; i <= count; i++) {
                            if(loopL > 0) {
                                totalPrice = totalPrice + (price / 2);
                                loopL--;
                            } else {
                                totalPrice += price;
                            }
                        }
                        $(this).find('.price').attr('data-total-promo', totalPrice);
                    } else if (countF > 0 && count > 1) {
                        console.log('Level 4');
                        var loopL = 0;
                        if ($(this).find('.price').attr('data-promo-tr') === 'true') {
                            if(countF >= count) {
                                loopL = countF;
                                countF = countF - count;
                            } else if (count > countF) {
                                loopL = countF;

                                var tmp = count - countF;
                                if (tmp % 2 === 0 ) {
                                    loopL += tmp / 2;
                                } else {
                                    loopL += Math.floor(tmp / 2);
                                }
                            }
                        } else {
                            if(countF >= count) {
                                loopL = count;
                                countF = countF - count;
                            } else if (countF < count) {
                                loopL = countF;
                                countF = 0;
                            }
                        }
                        for(var i = 1; i <= count; i++) {
                            if(loopL > 0) {
                                totalPrice = totalPrice + (price / 2);
                                loopL--;
                            } else {
                                totalPrice += price;
                            }
                        }
                        $(this).find('.price').attr('data-total-promo', totalPrice);
                    }
                }
            }
        });
    }

    // Change count in small basket
    if($('#menu_cart').length) {
        $(document).on('blur', '#menu_cart .counter input', function () {
            var id = $(this).closest('.cart_item').attr('data-id'),
                count = $(this).val();

            changeCount(id, count);
            discountOneHalfTwo($basketBlock.find('.cart_item'));
            calculateSmallCard();
        });
        $(document).on('click', '#menu_cart .counter span', function () {
            var id = $(this).closest('.cart_item').attr('data-id'),
                count = $(this).closest('.counter').find('input').val();

            changeCount(id, count);
            discountOneHalfTwo($basketBlock.find('.cart_item'));
            calculateSmallCard();
        });
    }

    //Change count in checkout page
    if($('.checkout_order .small_list-wrap').length) {
        $(document).on('blur', '.small_list_order .counter input', function () {
            let id = $(this).closest('.basket_article-small').attr('data-id'),
                count = $(this).val();

            changeCount(id, count);
            discountOneHalfTwo($checkoutRow.find('.basket_article-small'));
            calculateCheckout();
        });
        $(document).on('click', '.small_list_order .counter span', function () {
            let id = $(this).closest('.basket_article-small').attr('data-id'),
                count = $(this).closest('.counter').find('input').val();

            changeCount(id, count);
            discountOneHalfTwo($checkoutRow.find('.basket_article-small'));
            calculateCheckout();
        });
    }

    /**
     * @param id
     * @param count
     */
    function changeCount(id, count) {
        let  cookiesCard = JSON.parse(getCookie('card'));
        cookiesCard[id]['count'] = Number(count);

        setCookie('card', JSON.stringify(cookiesCard));
    }

    //Checkout page
    var $checkoutRow = $('.checkout_order');
    function calculateCheckout() {
        let total = 0,
            totalWithoutPromo = 0;

        $checkoutRow.find('.basket_article-small').each(function () {
            var counter = Number($(this).find('.counter input').val()),
                price = Number($(this).find('.price').attr('data-price')),
                promo = Number($(this).find('.price').attr('data-total-promo'));

            if(promo > 0) {
                total = total + promo;
            } else {
                total = total + (counter * price);
            }
            totalWithoutPromo = totalWithoutPromo + (counter * price);
        });

        let $cartTotal = $checkoutRow.find('.basket_article-small--total'),
            cost_delivery = Number($cartTotal.find('input[name="cost_delivery"]').val());

        let totalSum = total + cost_delivery,
            discount = totalWithoutPromo - total;

        //Promo discount
        let promoCodeD = discountPromoCode(total, $('input[name="promo_discount"]'));
        if(promoCodeD) {
            discount += promoCodeD;
            total = total - promoCodeD;
        }

        $cartTotal.find('input[name="cost"]').val(total.toFixed(2));
        $cartTotal.find('input[name="discount_cost"]').val(discount.toFixed(2));


        //Hide if zero
        if(discount <= 0) {
            $cartTotal.find('.price_wrap').css('display', 'none');
            $cartTotal.find('.price_discount_wrap').css('display', 'none');
        } else {
            $cartTotal.find('.price_wrap').removeAttr('style');
            $cartTotal.find('.price_discount_wrap').removeAttr('style')
        }

        $cartTotal.find('#price').html(totalWithoutPromo.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $cartTotal.find('#price_discount').html('-' + discount.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $cartTotal.find('#total').html(total.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));

        //Insert to step 4
        $('#row_fourth .total-big').html(totalSum.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $('#row_fourth .price .value b').html(total.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
    }
    if($checkoutRow.length) {
        discountOneHalfTwo($checkoutRow.find('.basket_article-small'));
        calculateCheckout();
    }

    //Delete product from cart
    $(document).on('click', '.cart_item .remove, .basket_article .remove, .small_list_order .remove', function (e) {
        e.preventDefault();
        setCookie('delete_id', $(this).closest('.cart_item').attr('data-id'));

        if($('#menu_cart').length) {
            $('#menu_cart').animate({right: '-100%'}, 200, function () {
                if($(window).width() <= 767) {
                    $('.overlay_page').css('z-index', 13);
                }
                $('.actions_popup--remove, .overlay_page').fadeIn(200);
            });
        } else {
            $('.actions_popup--remove, .overlay_page').fadeIn(200);
            if($(window).width() <= 767) {
                $('.overlay_page').css('z-index', 6);
            }
        }
    });

    //Remove big z-index
    if($(window).width() <= 767) {
        $('.overlay_page, .actions_popup--remove .close-button').on('click', function () {
            $('.overlay_page').css('z-index', 6);
        })
    }

    $('.actions_popup--remove .confirm-delete').on('click', function (e) {
        e.preventDefault();

        //Push delete event GA
        var $deleteProduct = null,
            name = '';
        if($('.cart_items').length) {
            $deleteProduct = $('.cart_items .cart_item[data-id="'+ getCookie('delete_id') +'"]');
            name = $deleteProduct.find('.item_info .item_name').html();
        } else if($('.checkout_wrap-cart--items').length) {
            $deleteProduct = $('.checkout_wrap-cart--items .basket_article[data-id="'+ getCookie('delete_id') +'"]');
            name = $deleteProduct.find('h3 a').html();
        } else if($('.small_list-wrap').length) {
            $deleteProduct = $('.small_list-wrap .basket_article-small[data-id="'+ getCookie('delete_id') +'"]');
            name = $deleteProduct.find('h3 a').html();
        }
        dataLayer.push({
            'ecommerce': {
                'currencyCode': 'UAH',
                'remove': {
                    'products': [{
                        'name': ''+ name +'',
                        'id': ''+ getCookie('delete_id') +'',
                        'price': ''+ $deleteProduct.find('.price').attr('data-price') +'',
                        'quantity': $deleteProduct.find('.counter input').val()
                    }]
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Removing a Product from a Shopping Cart',
            'gtm-ee-event-non-interaction': 'False',
        });



        //Delete product
        deleteProduct(getCookie('delete_id'));
        showHideBuy();

        if(window.innerWidth < 1092){
            overlayClose();
        } else {
            enable_scroll();
        }

        $('.actions_popup--remove, .overlay_page').fadeOut(200, function () {
            $('.overlay_page').css('z-index', 6);
        });

        //Check if last item
        let $checkoutOrder = $('.checkout_order');
        if($checkoutOrder.length) {
            document.location.reload(true);
            // if(!$checkoutOrder.find('.small_list-wrap .basket_article-small').length) {
            //     document.location.reload(true);
            // }
        }
    });

    function deleteProduct(id) {
        //Delete from cache
        var cookiesCard =  JSON.parse(getCookie('card'));
        delete cookiesCard[id];
        setCookie('card', JSON.stringify(cookiesCard));

        //Delete from card page
        $('.checkout_wrap-cart .basket_article[data-id="'+ id +'"]').remove();
        discountOneHalfTwo($('.basket_article'));
        calculateCart();

        if($.isEmptyObject(cookiesCard)) {
            var $wrapCard = $('.checkout_wrap-cart--items');
            if($wrapCard.length) {
                $wrapCard.html('<img src="/images/tmp/empty.png" alt="empty">');
            }
        }

        //Delete from small basked
        $('#menu_cart .cart_items .cart_item[data-id="'+ id +'"]').remove();
        discountOneHalfTwo($basketBlock.find('.cart_item'));
        calculateSmallCard();

        //Delete from checkout page
        $('.small_list-wrap .basket_article-small[data-id="'+ id +'"]').remove();
        discountOneHalfTwo($checkoutRow.find('.basket_article-small'));
        calculateCheckout();
    }

    // Motion stickers
    function eye() {
        let $wrap = document.querySelector('.wrap_page'),
            $stickers = document.querySelectorAll('.sticker:not(.without_animation)');

        $('.sticker').each(function() {
            $(this).attr('data-top', $(this).css('top'));
        })
        $wrap.addEventListener('mousemove', function (e) {
            for (var i = 0; i < $stickers.length; ++i) {
                var $el = $stickers[i],
                    bb = $el.getBoundingClientRect(),
                    cx = bb.left + bb.width / 2,
                    cy = bb.top + bb.height / 2,
                    offsetX = (e.clientX-cx)/10,
                    offsetY = (e.clientY-cy)/10;
                $el.style.transform = "translate3d("+Math.fround(offsetX/10)+"px,"+Math.fround(offsetY/10)+"px,0px)";
            }
        });

        $(window).scroll(function(e){
            for (var i = 0; i < $stickers.length; ++i) {
                var scrolled = $stickers[i].getBoundingClientRect().top;
                if(i % 2 === 0) {
                    $stickers[i].style.top = (parseInt($stickers[i].getAttribute('data-top')) - (scrolled*.1)) + 'px';
                } else {
                    $stickers[i].style.top = (parseInt($stickers[i].getAttribute('data-top')) - (scrolled*.3)) + 'px';
                }
            }
        });
    }
    if(window.innerWidth >= 768){
        eye();
    }

    /**
     * Cities info
     */
    let $infoCity = $('#info-city');
    if($infoCity.length) {
        $infoCity.blur(function () {
            let $this = $(this);
            setTimeout(function () {
                $.ajax({
                    type: "POST",
                    url: '/' + LANGUAGE + '/get_shops_city',
                    data: {id: $this.attr('data-id'), inform: 1}
                }).done(function (data) {
                    if(data.li) {
                        $infoCity.closest('.wrap_city').find('.list_shops .mCSB_container').html(data.li);
                    } else {
                        $infoCity.closest('.wrap_city').find('.list_shops .mCSB_container').html('');
                    }
                });
            }, 200);
        });
    }

    /**
     * Submit search
     */
    $('.search_content .trigger-submit').on('click', function () {
        $(this).parent().find('form.search').submit();
    });

    /**
     * Subscribe
     */
    let $subscribeForm = $('#subscribe');
    let $subscribeFormInit = $subscribeForm.validate({
        highlight: function (element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function (element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function (form) {
            var formData = new FormData($(form)[0]);
            $(form).find('button[type=submit]').prop('disabled', true);
            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/subscribe',
                processData: false,
                contentType: false,
                data: formData
            }).done(function (data) {
                if (data.success) {
                    $('.actions_popup--subscribe, .overlay_page').fadeIn(200, function () {
                        $subscribeForm[0].reset();
                        $subscribeFormInit.resetForm();
                    });
                }
            });
        }
    });

    /**
     * Hide header
     */
    var lastScrollTop = 0,
        $header = $(window).width() > 1092 ? $('header .header_desktop') : $('header .header_mobile');

    var actionHideHeader = 0,
        blockActionHeader = 0;
    $(window).scroll(function(){
        if(blockActionHeader === 1 || actionHideHeader === 1) return false;
        var st = $(this).scrollTop();
        if (st > lastScrollTop && st > 50){
            if(!$header.hasClass('hide')) {
                $header.addClass('hide');
                actionHideHeader = 1;
                $header.css("opacity", "1.0").animate({opacity: 0}, 200, function(){
                    $header.css("visibility", "hidden");
                    $header.closest('header').addClass('min_height');
                    actionHideHeader = 0;
                });
            }
        } else if (st < lastScrollTop || st >= 50) {
            if($header.hasClass('hide')) {
                $header.closest('header').removeClass('min_height');
                $header.removeClass('hide');
                actionHideHeader = 1;
                $header.css({opacity: 0, visibility: "visible"}).animate({opacity: 1}, 200, function () {
                    actionHideHeader = 0;
                });
            }
        }
        lastScrollTop = st;
    });

    /**
     * Position popups
     */
    var $actionPopups = $('.actions_popup');
    if($actionPopups.length && $(window).width() > 1200) {
        var windowW = $(window).width(),
            windowH = $(window).height();
        $actionPopups.each(function () {
            var widthEl = $(this).outerWidth(true),
                heightEl = $(this).outerHeight(true);
            $(this).css({
                'left': (windowW - widthEl) / 2 + 'px',
                'top': (windowH - heightEl) / 2 + 'px'
            });
        });
    }

    /**
     * Auth & register users
     */
    var $loginCart = $('#menu_profile');
    if($loginCart.length) {
        var $actionAuth = $('.actions_popup--auth');

        //Hack for fucking chrome!!!!!!!
        setTimeout(function () {
            $('#menu_profile').find('input').prop('readonly', false);
        }, 1500);

        $loginCart.find('.cart_block .to_bl').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            $this.closest('.cart_block').fadeOut(200, function () {
                $this.closest('.row').find('#'+$this.attr('data-id')).fadeIn(200);
            });
        });

        $loginCart.find('form.auth_form').each(function () {
            var $thisForm = $(this),
                $thisFormInit = $thisForm.validate({
                        highlight: function (element) {
                            $(element).parent().addClass("error").removeClass("valid");
                        },
                        unhighlight: function (element) {
                            $(element).parent().removeClass("error").addClass("valid");
                        },
                        submitHandler: function (form) {
                            var $form = $(form),
                                formData = new FormData($(form)[0]);
                            $form.find('.error_massage').fadeOut(100);
                            $form.find('button[type=submit]').prop('disabled', true);

                            var error = {};
                            $.ajax({
                                type: "POST",
                                url: $form.attr('action'),
                                processData: false,
                                contentType: false,
                                data: formData
                            }).done(function (data) {
                                //console.log(data);
                                //success auth
                                if(data.success) {
                                    //Reload after auth
                                    if(data.auth === true) {
                                        if(LANGUAGE !== 'uk') {
                                            window.location.href = LANGUAGE + '/profile/data';
                                        } else {
                                            window.location.href = '/profile/data';
                                        }
                                        return true;
                                    }

                                    $loginCart.animate({right: '-100%'}, 200);
                                    $('.menu.menu--mobile').animate({right: '-100%'}, 200);

                                    $actionAuth.find('.content p').html(data.success);
                                    $actionAuth.fadeIn(200);
                                    setTimeout(function () {
                                        $loginCart.attr('data-auth', 'true');
                                        $loginCart.find('.cart_block').fadeOut(100, function () {
                                            if(data.auth) {
                                                $loginCart.find('#user_profile').fadeIn(100);
                                            } else {
                                                $loginCart.find('#pr_1').fadeIn(100);
                                            }
                                        });
                                    }, 200);
                                }

                                //error
                                if(data.errors_auth) {
                                    // error['email'] = '';
                                    // error['password'] = '';
                                    $thisFormInit.showErrors(error);
                                    $form.find('.error_massage').html(data.errors_auth).fadeIn(100);
                                }
                                if(data.go_activate) {
                                    error['email'] = '';
                                    $thisFormInit.showErrors(error);
                                    $form.find('.error_massage').html(data.go_activate).fadeIn(100);
                                }

                                if(data.errors) {
                                    var err = {};
                                    Object.keys(data.errors).forEach(function(key) {
                                        err[key] = data.errors[key][0];
                                    });
                                    $thisFormInit.showErrors(err);
                                }

                                $form.find('button[type=submit]').prop('disabled', false);

                            }).fail(function (jqXHR, textStatus) {
                                //alert('Ooooops!')
                                //console.log(jqXHR);
                                //console.log( "Request failed: " + textStatus );

                                if(jqXHR.status === 423) {
                                    error = {};
                                    $thisFormInit.showErrors(error);
                                    $form.find('.error_massage').html(jqXHR.responseJSON.errors.email[0]).fadeIn(100);
                                }

                                $form.find('button[type=submit]').prop('disabled', false);
                            });
                        }
                    });

            //reset after close
            $('body').on('click', '.overlay_page, #menu_profile .close-button', function () {
                if($('#menu_profile').attr('data-auth') === 'true') return false;

                $thisForm[0].reset();
                $thisFormInit.resetForm();
                $loginCart.find('.cart_block').fadeOut(100, function () {
                    $loginCart.find('#pr_1').fadeIn(100);
                    $loginCart.find('.error_massage').fadeOut(100);
                });
            });

            //reset after change action
            $loginCart.find('.cart_block .to_bl').on('click', function (e) {
                e.preventDefault();
                $thisForm[0].reset();
                $thisFormInit.resetForm();
                $loginCart.find('.error_massage').fadeOut(100);
            });

        });

    }

    var $changePForm = $('#change_password');
    if($changePForm.length) {
        $changePForm.validate({
            rules: {
                password: "required",
                password_confirmation: {
                    equalTo: "#res_password"
                }
            },
            highlight: function (element) {
                $(element).parent().addClass("error").removeClass("valid");
            },
            unhighlight: function (element) {
                $(element).parent().removeClass("error").addClass("valid");
            },
            //Send form
            submitHandler: function(form){
                $(form).off('submit').submit();
            }
        });
    }

    /**
     * Booking times
     */

    let dayIndex = $('.booking_time_calendar .item:first-child .header .name.first').index();
    let $timeSlider = $(".times_slider").owlCarousel({
        lazyLoad:true,
        margin: 10,
        loop:false,
        items: 1,
        nav:false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        startPosition: (dayIndex === 6) ? 1 : 0,
        dots: false,
        onInitialized: function () {
            if($(window).width() <= 1199) {
                $(".times_slider .item").mCustomScrollbar({axis: 'x'});
            }
        }
    });


    //Events
    $('.time_slider_control .next').on('click', function (e) {
        $timeSlider.trigger('next.owl.carousel');
    });
    $('.time_slider_control .prev').on('click', function () {
        $timeSlider.trigger('prev.owl.carousel');
    });


    //Listen events
    $timeSlider.on('changed.owl.carousel', function(event) {
        let index = event.item.index + 1,
            $timeSlider = $('.wrap_booking .time_slider_control');

        if(index === 1) {
            $timeSlider.find('.prev').addClass('disabled');
            $timeSlider.find('.next').removeClass('disabled');
        } else if(index > 1 && index < event.item.count) {
            $timeSlider.find('.next, .prev').removeClass('disabled');
        } else if(index === event.item.count) {
            $timeSlider.find('.prev').removeClass('disabled');
            $timeSlider.find('.next').addClass('disabled');
        }

        let id = event.relatedTarget.current();
        let $findEl = $('.time_slider_control li:not([data-id="'+ id +'"])');
        $findEl.animate({opacity: 0}, 200, function() {
            $findEl.hide();

            let $showBl = $('.time_slider_control li[data-id="'+ id +'"]');
            $showBl.show();
            $showBl.animate({opacity: 1}, 200);
        });

        //Destroy scroll for F**ing IOS
        if($(window).width() < 1199) {
            let $itemS = $('.times_slider .item');
            $itemS.mCustomScrollbar("destroy");
            $itemS.mCustomScrollbar({axis: 'x'});
        }
    });

    //Get select day
    let $sliderTimes = $('.times_slider'),
        $bookingSecond = $('#booking-second'),
        selectedData = null,
        frontData = null,
        dayId = null,
        timeId = null;

    $sliderTimes.on('click', '.times span:not(.disabled)', function () {
        $sliderTimes.find('.times span:not(.disabled)').not($(this)).removeClass('active');
        $(this).toggleClass('active');

        if($(this).hasClass('active')) {
            selectedData = $(this).parent().attr('data-date') + ' ' + $(this).find('i').html();
            frontData = $(this).parent().attr('data-front') + ' ' + $(this).find('i').html();
            dayId = $(this).parent().attr('data-id');
            timeId = $(this).attr('data-id');

            //Save to cookies
            let dataToC = {
                'selected_data': selectedData,
                //'front_data': frontData,
                'day_id': dayId,
                'time_id': timeId
            };
            setCookie('doctor_booking', JSON.stringify(dataToC));
            $bookingSecond.removeClass('disabled');
        } else {
            selectedData = null;
            frontData = null;
            setCookie('doctor_booking', '');

            $bookingSecond.addClass('disabled');
        }
    });

    //To form page
    $bookingSecond.on('click', function (e) {
        if($(this).hasClass('disabled')) {
            e.preventDefault();
        }
    });

    //Sent time to server
    let timesForm = $('#booking_time').validate({
        focusInvalid: false,
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function(form){
            let formData = new FormData($(form)[0]);

            $(form).find('button[type=submit]').prop('disabled', true);
            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/booking_doctor',
                processData: false,
                contentType: false,
                data: formData
            }).done(function (data) {
                if(data.error) {
                    alert(data.error);
                    $(form).find('button[type=submit]').prop('disabled', false);
                    return false;
                }

                if(data.success) {
                    window.location.href = data.url;
                }
            });
        }

    });

});

/**
 * Add remove from favorite
 *
 */
let $addTofavorite = $('.add_to_favorite');
if($addTofavorite.length) {

    $addTofavorite.on('click', function (e) {
        e.preventDefault();

        let $this = $(this);
        let data = {
            product_id: $(this).attr('data-id')
        };

        $.ajax({
            type: "POST",
            url: '/' + LANGUAGE + '/add_to_favorite',
            data: data
        }).done(function (data) {
            let $fav = $('.actions_popup--add-favorite');
            if(data.info) {
                $fav.find('.style_h2').html(data.info);
            }
            $('.actions_popup--add-favorite, .overlay_page').fadeIn(200);

            if(data.added === true) {
                $this.addClass('active');
            } else {
                $this.removeClass('active');
            }

            //Update count
            getFavorite();

            if(window.innerWidth < 1092){
                $.lockBody();
            }
        });
    });
}

//Remove favorite
let $remFav = $('.remove_favorite');
if($remFav.length) {
    let ID_del_fav = 0;
    $remFav.on('click', function (e) {
        e.preventDefault();
        ID_del_fav = $(this).parent().attr('data-id');

        //Show conform popup
        $('.actions_popup--remove-favorite, .overlay_page').fadeIn(200);

        if(window.innerWidth < 1092){
            $.lockBody();
        }
    });

    //confirm delete
    $('.confirm-delete-favorite').on('click', function (e) {
        e.preventDefault();

        if(ID_del_fav !== 0) {
            let data = {
                product_id: ID_del_fav
            };

            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/add_to_favorite',
                data: data
            }).done(function (data) {
                $('.favorite_products .item[data-id="'+ ID_del_fav +'"]').remove();
                $('.actions_popup, .overlay_page').fadeOut(200);

                //Update count
                getFavorite();

                ID_del_fav = 0;

                if(window.innerWidth < 1092){
                    $.unlockBody();
                }
            });
        }
    })
}

function getFavorite() {
    $.ajax({
        type: "GET",
        url: '/' + LANGUAGE + '/get_favorite',
    }).done(function (data) {
        if(data.success) {
            let $fav = $('.count_favorite');
            $fav.html('['+ data.success.count +']');
            if(data.success.count > 0) {
                $fav.closest('.favorite_info').find('.empty_fav').css('display', 'none');
                $fav.closest('.favorite_info').find('.full_fav').removeAttr('style');
            } else {
                $fav.closest('.favorite_info').find('.full_fav').css('display', 'none');
                $fav.closest('.favorite_info').find('.empty_fav').removeAttr('style');

                if($('.favorite_products').length) {
                    $('.favorite_products').html('<div class="empty_image">' +
                        '            <img src="/images/tmp/empty.png" alt="empty">' +
                        '        </div>');
                }
            }
        }
    });
}
if($('.favorite_info').length) {
    getFavorite();
}

/**
 * Big slider
 */
let $bigSlider = $('.full_page_slider');
if($bigSlider.length) {

    //Replace webp
    if(!self.createImageBitmap) {
        $bigSlider.find('video').each(function () {
            $(this).attr('poster', $(this).attr('data-png'));
        });
    }

    //Get options
    let slAutoplay = ($bigSlider.attr('data-autoplay')) ? Number($bigSlider.attr('data-autoplay')) : 0,
        slSpeed = ($bigSlider.attr('data-speed-play')) ? Number($bigSlider.attr('data-speed-play')) : 250,
        slPause = ($bigSlider.attr('data-pause')) ? Number($bigSlider.attr('data-pause')) : 5000;


    $bigSlider.on('initialized.owl.carousel', function(event) {
        let itemEl = event.item.index + 1,
            $activeItem = $(event.target).find('.owl-item:nth-child('+ itemEl +')');

        if($activeItem.find('video').length) {
            playVideo($activeItem, $bigSlider)
        }
    });


    let $initialBS = $bigSlider.owlCarousel({
        loop:true,
        margin: 0,
        nav:false,
        autoWidth:true,
        items:1,
        autoplay: (slAutoplay === 0) ? false : true,
        autoplayTimeout: slPause,
        autoplaySpeed: slSpeed
    });

    $initialBS.on('changed.owl.carousel', function(event) {
        let itemEl = event.item.index + 1,
            $activeItem = $(event.target).find('.owl-item:nth-child('+ itemEl +')');

        stopAllVideos($(event.target).find('.owl-item video'));

        if($activeItem.find('video').length) {
            playVideo($activeItem, $initialBS)
        }
    });


    //Volume control
    let muteStatus = false;
    $bigSlider.on('click', '.item .volume-control', function () {
        $(this).toggleClass('off-s');

        let $thisVideo = $(this).siblings('video')[0];
        if(muteStatus) {
            $thisVideo.muted = true;
            muteStatus = false;
        } else {
            $thisVideo.muted = false;
            muteStatus = true;
        }
    });
}


function playVideo($activeItem, $initialBS) {
    let $video = $activeItem[0].querySelector('video');

    //Play video
    $video.volume = 0.5;
    let source = $video.querySelector('source');
    source.src = source.getAttribute('data-src');
    $video.load();
    $video.play();

    bindVideoScroll(true, $initialBS)
}

function bindVideoScroll(status, $initialBS) {
    let flagStart = false;
    if(status) {
        $(document).on('scroll.stop.video', function () {
            if($(this).scrollTop() > 300) {
                stopAllVideos($bigSlider.find('.owl-item video'));
                flagStart = true;
                //bindVideoScroll(false);
            } else if($(this).scrollTop() <= 300 && flagStart) {
                flagStart = false;
                let $thisVideo = $initialBS.find('.owl-item.active video');
                if($thisVideo.length) {
                    $thisVideo[0].play();
                }

            }
        });
    } else {
        $(document).unbind('scroll.stop.video');
    }
}

function stopAllVideos($videos) {
    $videos.each(function () {
        $(this)[0].pause();
    })
}

/**
 * Stories
 */
let $stories = $('.stories_list'),
    timerStHover = '';
$stories.find('article a').hover(function () {
    clearTimeout(timerStHover);
    let $self = $(this);
    timerStHover = setTimeout(function () {
        $self.find('img').fadeIn(200);
    }, 300)
}, function () {
    clearTimeout(timerStHover);
    $(this).find('img').fadeOut(200);
});

/**
 * Replace webp style if webp not supported
 */
$(document).ready(function () {
    if ($('html').hasClass('no-webp')) {
        $('.webp-gb-style').each(function () {
            var imgUrl = $(this).attr('data-img');
            $(this).removeAttr('style');
            $(this).css({
                'background': 'url(' + imgUrl + ') center no-repeat',
                'background-size': 'cover'
            });
        });
    }
});
